(function () {
  "use strict";

  function setupReviewCarousel(root) {
    var track = root.querySelector("[data-review-track]");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-review-slide]"));
    var previous = root.querySelector("[data-review-prev]");
    var next = root.querySelector("[data-review-next]");
    var counter = root.querySelector("[data-review-counter]");
    if (!track || slides.length < 2 || !previous || !next) return;

    var index = 0;
    var scrollFrame = 0;

    function sync(nextIndex) {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      if (counter) counter.textContent = String(index + 1) + " / " + String(slides.length);
      slides.forEach(function (slide, slideIndex) {
        if (slideIndex === index) slide.setAttribute("aria-current", "true");
        else slide.removeAttribute("aria-current");
      });
    }

    function targetLeft(slide) {
      var trackBox = track.getBoundingClientRect();
      var slideBox = slide.getBoundingClientRect();
      return track.scrollLeft + slideBox.left - trackBox.left - 2;
    }

    function goTo(nextIndex) {
      var target = Math.max(0, Math.min(slides.length - 1, nextIndex));
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      track.scrollTo({ left: targetLeft(slides[target]), behavior: reduce ? "auto" : "smooth" });
      sync(target);
    }

    previous.addEventListener("click", function () { goTo(index - 1); });
    next.addEventListener("click", function () { goTo(index + 1); });
    track.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      goTo(index + (event.key === "ArrowRight" ? 1 : -1));
    });
    track.addEventListener("scroll", function () {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        var trackBox = track.getBoundingClientRect();
        var nearest = slides.reduce(function (best, slide, slideIndex) {
          var distance = Math.abs(slide.getBoundingClientRect().left - trackBox.left);
          return distance < best.distance ? { distance: distance, index: slideIndex } : best;
        }, { distance: Infinity, index: 0 });
        if (nearest.index !== index) sync(nearest.index);
      });
    }, { passive: true });

    root.classList.add("is-enhanced");
    sync(0);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-review-carousel]"), setupReviewCarousel);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
